import { render, staticRenderFns } from "./SwipeTab.vue?vue&type=template&id=575e3fe4"
import script from "./SwipeTab.vue?vue&type=script&lang=js"
export * from "./SwipeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports